import s from "./TourFeatureStrip.module.scss";

import {
  CameraIcon,
  DroneIcon,
  PrivateTourIcon,
  PickupIcon,
  SpotIcon,
  SurfingIcon,
  JetIcon,
  EmptyHandIcon,
  LanguageIcon,
} from "../TourIcons/TourIcons";

const WaveIcon = () => (
  <svg className={s.wave} viewBox="0 0 58 10">
    <path d="M1 5C5 1 9 1 13 5C17 9 21 9 25 5C29 1 33 1 37 5C41 9 45 9 49 5C52 2 55 2 57 5" />
  </svg>
);

const TEXTS = {
  JP: {
    title: "どんな体験ができる？",
    description:
      "他に誰もいない秘境で、全てを忘れる非日常体験に癒されてください！写真・動画・ドローン撮影まで楽しめる特別なツアーです。",
  },
  EN: {
    title: "What can you experience?",
    description:
      "A special private tour where you can explore scenic and hidden spots in Miyakojima while enjoying photo, video, and drone shooting.",
  },
  中文: {
    title: "可以体验什么？",
    description:
      "这是一项特别的私人行程，可以巡游宫古岛的绝景和秘境，并体验照片、视频和无人机拍摄。",
  },
  한국어: {
    title: "어떤 체험을 할 수 있나요?",
    description:
      "미야코지마의 절경과 숨은 명소를 둘러보며 사진, 영상, 드론 촬영까지 함께 즐길 수 있는 특별한 투어입니다.",
  },
};

const iconMap = {
  camera: <CameraIcon />,
  drone: <DroneIcon />,
  private: <PrivateTourIcon />,
  pickup: <PickupIcon />,
  spot: <SpotIcon />,
  surfing: <SurfingIcon />,
  jet: <JetIcon />,
  emptyHand: <EmptyHandIcon />,
  multilingual: <LanguageIcon />,

  // 専用アイコンがないものは一旦代用
  option: <PrivateTourIcon />,
  schedule: <PickupIcon />,
};

const getLabel = (item, language) => {
  if (typeof item === "string") return item;

  return item.label?.[language] || item.label?.JP || "";
};

const getIcon = (item) => {
  if (typeof item === "string") return <CameraIcon />;

  return iconMap[item.icon] || <CameraIcon />;
};

const TourFeatureStrip = ({ highlights = [], language = "JP", intro }) => {
  const currentText = TEXTS[language] || TEXTS.JP;

  return (
    <section className={s.root}>
      <div className={s.inner}>
        <div className={s.about}>
          <h2 className={s.title}>
            {currentText.title}
            <WaveIcon />
          </h2>

          <p>{intro || currentText.description}</p>
        </div>

        <div className={s.items}>
          {highlights.map((item) => {
            const label = getLabel(item, language);

            return (
              <div className={s.item} key={item.key || label}>
                <div className={s.icon}>{getIcon(item)}</div>

                <div>
                  <h3>{label}</h3>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default TourFeatureStrip;
